$(document).ready(() => {
  intervalTime = 500;

  function loadIntervalCompare(variants, discountPercentage, currency){
    interval((title, context)=>{
      const price = variants.find(v => v.title.includes(title)).price;
                                              //Para uso internacional aqui provavelmenet deve ser utilizado currency invés de "R$"
      const priceValue = Number(price.replace("R$", "").replace(/\./g, "").replace(",", "."));
      const newPrice = (priceValue * discountPercentage).toFixed(2);
      const strNewPrice = currency + ' ' + newPrice.toString().replace('.',',');
      const priceElement = $(`<div class="price__regular">
                                <del class="ymq-b2b-cp-compare-price">
                                  <span>${price}</span>
                                </del><br class="price-space">
                                <span class="ymq-b2b-current-product-price new__price-margin"><b>${strNewPrice}</b></span>
                              </div>`);
      $(context).append(priceElement);
    });
  }

  function loadInterval(variants) {
    interval((title, context)=>{
      const price = variants.find(v => v.title.includes(title)).price;
      const priceElement = $(`<div class="price__regular ">
                                <span class="ymq-b2b-current-product-price">${price}</span>
                              </div>`);
      $(context).append(priceElement);
    });
  }

  function interval(callback){
    const interval = setInterval(() => {
      
    const dataMetacamp = $('#product-metacamp').attr('data-metacamp');
      //remove o campo "Tipo" antes do título dos elementos TintaComChip
      if(dataMetacamp){
        console.log('existo')
        $('.multivariants_block_option_label').remove();
      }
      const containers = $('.multivariants_block_last_holder_labels');
  
      if (containers.length > 0) {
        clearInterval(interval);
  
        containers.each(function () {  
          // Encontrar o título dentro do container específico
          const title = $(this).find('.multivariants_block_label .mkmid .mkmid_m').text().trim();
  
          // Verificar se encontramos o título e pegar o texto
          if (title.length > 0) {
            callback(title, this);
          }
        });
      }
    }, intervalTime);
  }

  const dataDiv = $('#product-metacamp');
  const dataMetacamp = dataDiv.attr('data-metacamp');
  const productId = dataDiv.attr('data-product-id');
  
  const variantTitles = dataDiv.attr('data-variant-titles')
                                .split(',')
                                .map(title => title.trim());

  const variantPrices = dataDiv.attr('data-variant-prices')
                                .split(',')
                                .map(price => price.trim() / 100);
  const variants =[]
  if(variantPrices.length == variantTitles.length){
    for(let i = 0; i < variantPrices.length; i++){
      const variant = {
        title: variantTitles[i],
        price: variantPrices[i]
      }
      variants.push(variant);
    }
  }

  const observer = new MutationObserver((mutations) => {
    // const container = $('.multivariants_block_last_holder_labels')
    
    const ymqSpan = $(`[ymq-b2b-product-id='${productId}']`);
    if(ymqSpan.length > 0){
      const ymqMoneySpan = ymqSpan?.children('.ymq-b2b-price-span');
      const ymqValue = Number(ymqMoneySpan?.first().text().replace("R$", "").replace(/\./g, "").replace(",", "."));

      if(ymqValue == 0){
        return
      }
      observer.disconnect(); //encontramos, podemos parar.
      
      const currency =  ymqMoneySpan.first().text().match(/[^\d.,]+/g)?.[0].trim() || '';
      const formattedVariants = variants.map(variant=>{
        const price = `${currency} ${variant.price.toString().replace('.',',')}`
        return {
          title: variant.title,
          price
        }
      });

      const compareElement = ymqSpan?.siblings('.ymq-b2b-cp-compare-price');

      if(compareElement.length > 0){
        const ymqOldValue = Number(compareElement.first().text().replace("R$", "").replace(/\./g, "").replace(",", "."));
        const discountPercentage = ymqValue / ymqOldValue;
        loadIntervalCompare(formattedVariants, discountPercentage, currency);
        return
      }
      
      loadInterval(formattedVariants);
      return
    }
  });

  // Configurar o observador para monitorar mudanças no DOM
  observer.observe(document.body, {
    childList: true,
    subtree: false,
  });
});